import { forEach } from "./utils";

let stickymenu = {

    siteHeader: null,
    tabNav: null,
    chapterHeader: null,
    siteHeaderPosTop: 0,
    tabNavPosTop: 0,
    chapterHeaderPosTop: 0,
    lastKnownScrollPosition: 0,
    ticking: false,
    isMobile: true,
    timeout: false, // holder for timeout id
    delay: 250, // delay after event is "complete" to run callback
    initTabNav: function () {
        this.tabNav = document.getElementById('tabnav');
        if (this.tabNav !== null) {
            this.tabNavPosTop = this.tabNav.offsetTop;
        }
    },

    initChapterHeader: function () {
        this.chapterHeader = document.getElementById('ChapterPage');
        if (this.chapterHeader !== null) {
            this.chapterHeaderPosTop = this.chapterHeader.offsetTop;
        }
    },
    init: function () {   
        this.siteHeader = document.getElementById("siteheader");

        this.siteHeaderPosTop = this.siteHeader.offsetTop;
        this.isMobile = window.innerWidth < 990;

          window.addEventListener('resize', function () {
            // clear the timeout
            clearTimeout(stickymenu.timeout);
            // start timing for event "completion"
            stickymenu.timeout = setTimeout(stickymenu.checkIfMobile, stickymenu.delay);
        });

        document.addEventListener('scroll', function (e) {           
            stickymenu.lastKnownScrollPosition = window.scrollY;
            if (!stickymenu.ticking) {
                window.requestAnimationFrame(function () {          
                    stickymenu.scrollTracking(stickymenu.lastKnownScrollPosition);
                    stickymenu.ticking = false;
                });

                stickymenu.ticking = true;
          }
        });
    },
    checkIfMobile: function () {
        stickymenu.isMobile = window.innerWidth < 990;

    },
    scrollTracking: function (position) {
        
        if (this.siteHeader !== null) {
            const fixedLimit = this.isMobile ? this.siteHeaderPosTop : this.siteHeaderPosTop + 54;
            if (position > fixedLimit) {
                this.siteHeader.classList.add("site-header--sticky");
                if (document.getElementById('Importantotice') !== null) {
                    document.getElementById('Importantotice').classList.add("important-notice--sticky");
                }
                if (this.tabNav !== null) {
                    this.tabNav.classList.add("tab-nav--sticky");
                }
                if (this.chapterHeader !== null) {
                    this.chapterHeader.classList.add("chapterheader--sticky");
                }
            } else {
                this.siteHeader.classList.remove("site-header--sticky");
                if (this.tabNav !== null) {
                    this.tabNav.classList.remove("tab-nav--sticky");
                }
                if (document.getElementById('Importantotice') !== null) {
                    document.getElementById('Importantotice').classList.remove("important-notice--sticky");
                }
                if (this.chapterHeader !== null) {
                    this.chapterHeader.classList.remove("chapterheader--sticky");
                }
                else {

                    Array.from(document.getElementsByClassName("row--overflow")).forEach(
                        function (element, index, array) {
                            element.scrollLeft = 0;
                        }
                    );
                }
            }
        }
    }
};


export { stickymenu };